import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NGXLogger } from "ngx-logger";
import { Subscription } from "rxjs";
import { timeout } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import {
  AssetCoverage,
  Benefict,
  DetailedProduct,
  ProductDescriptionImage,
  ProductItem
} from "../../../../core/models/products.model";
import { ProductKind } from "../../../../core/config/product-catalog";
import { DemoDialogService } from "../../../../core/services/dialog";
import { ProductCatalogService } from "../../../../core/services/product-catalog.service";
import { ProductService } from "../../../../core/services/products.service";
import { SiilaTranslationService } from "../../../../core/services/siila-translation.service";
import { I18nService } from "../../../services";
import { CaptchaService } from "../../../services/captcha.service";
import { MetaTagService } from "../../../services/meta-tag.service";
import { UrlCanonicalService } from "../../../services/url-canonical.service";
import { isMissingEntity } from "../../../utils/entity-lookup";
import { action } from "../../../utils/params";
import { isNumericRouteId } from "../../../utils/route-id";
import { DemoDialogComponent } from "../../dialogs";
@Component({
  selector: "app-grocs",
  templateUrl: "./grocs.component.html",
  styleUrls: [
    "./grocs.component.scss",
    "../product-list/product-list.component.scss",
    "../market-analytics/market-analytics.component.scss",
    "../spot/spot.component.scss"
  ]
})
export class GrocsComponent implements OnInit, OnDestroy {
  benefitPath = "grocs.benefits";
  mappingPath = "grocs.mapping.regions.";
  productId: number;
  routerSub: Subscription;
  product: DetailedProduct;
  assets: AssetCoverage;
  isVideo = false;
  videoId: string;
  totalAssetItems: string[];
  totalMarketItems: string[];
  products: ProductItem[];
  responsiveSub: Subscription;
  isMobile = false;
  showInvestor: boolean;
  currentCode: string;
  browserLang: string = "en";
  action = action;
  tagId = null;
  indexpic: string;
  indexbars: string;
  coverageAlt: string;
  picAlt: string;
  isServiceUnavailable: boolean = false;
  indicesavailable: string;

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private responsive: BreakpointObserver,
    private siilaTranslationService: SiilaTranslationService,
    private demo: DemoDialogService,
    private i18: I18nService,
    private metaTagService: MetaTagService,
    private captchaService: CaptchaService,
    private urlCanonical: UrlCanonicalService,
    private productCatalog: ProductCatalogService,
    private router: Router,
    private ngxLogger: NGXLogger
  ) {
    this.currentCode = environment.platformId;
    this.browserLang = this.siilaTranslationService.getCurrentLanguage();
    if (this.currentCode == "mx") {
      this.tagId = 64;
    }

    if (this.currentCode == "co") {
      this.tagId = 64;
    }

    if (this.currentCode == "br") {
      this.tagId = 60;
    }

    if (this.currentCode == "latam") {
      this.tagId = 68;
    }
  }

  productDescriptionImageAlt(benefits: Benefict) {
    let alt = "";

    if (benefits) {
      const productId = benefits.productId;
      const id = benefits.id;

      if (productId == 101 || productId == 106) {
        switch (id) {
          case 101:
          case 119:
            return this.siilaTranslationService.getImgSEOTranslation(
              "grocs.mappic"
            );
          case 103:
          case 121:
            return this.siilaTranslationService.getImgSEOTranslation(
              "grocs.interior"
            );
          case 102:
          case 120:
            return this.siilaTranslationService.getImgSEOTranslation(
              "grocs.dashboard"
            );
        }
      }

      if (productId === 108) {
        switch (id) {
          case 114:
            return this.siilaTranslationService.getImgSEOTranslation(
              "grocs.observations"
            );
          case 115:
            return this.siilaTranslationService.getImgSEOTranslation(
              "grocs.caprates"
            );
          case 116:
            return this.siilaTranslationService.getImgSEOTranslation(
              "grocs.discountrates"
            );
          case 117:
            return this.siilaTranslationService.getImgSEOTranslation(
              "grocs.rentgrowth"
            );
          case 118:
            return this.siilaTranslationService.getImgSEOTranslation(
              "grocs.vacancyAnal"
            );
        }
      }

      if (productId === 103 || productId == 105) {
        return this.siilaTranslationService.getImgSEOTranslation("grocs." + id);
      }

      if (!alt) {
        console.error("Product {} with ID {} does not have alt", productId, id);
      }
    }

    return alt;
  }

  productDescriptionImage(item: ProductDescriptionImage): string {
    return `${environment.cloudfrontURL}${item.filePathInBucket}/640w/${item.filename}`;
  }

  /**
   * Header illustration for the resolved product. Keyed on the catalog kind
   * rather than an id list: the same product is 101 on BR and 106 on LATAM, so
   * `id === 101` silently stopped matching as countries were added.
   */
  private applyHeaderImageAlt(kind: ProductKind): void {
    if (kind === "investor-survey") {
      this.indexpic = this.siilaTranslationService.getImgSEOTranslation(
        "investorsurvey.picworld"
      );
    } else if (kind === "grocs") {
      this.indexpic = this.siilaTranslationService.getImgSEOTranslation(
        "grocs.firstpic"
      );
    }
  }

  /**
   * Terminal 404 path. Routes IN-APP so the `prerender-status-code: 404`
   * `PageNotFoundComponent` emits lands in the same document the crawler is
   * rendering — a hard navigation would lose it and snapshot a soft-200.
   */
  private navigateToNotFoundPage(): void {
    this.router.navigateByUrl("/404", {
      state: { badURL: window.location.href }
    });
  }

  ngOnInit(): void {
    this.indexpic = this.siilaTranslationService.getImgSEOTranslation(
      "index.pic" + environment.platformId
    );
    this.indexbars = this.siilaTranslationService.getImgSEOTranslation(
      "index.bars" + environment.platformId
    );
    this.coverageAlt = this.siilaTranslationService.getImgSEOTranslation(
      "index.coverage" + environment.platformId
    );

    this.indicesavailable = this.siilaTranslationService.getImgSEOTranslation(
      "indicesavailable"
    );

    this.picAlt = this.siilaTranslationService.getImgSEOTranslation(
      "investorsurvey.picAlt"
    );

    this.routerSub = this.route.paramMap.subscribe(params => {
      const rawId = params.get("id");
      // No addressable id (`/products/products/fibra-analytics` is this route
      // with `id = "products"`) — answer 404 without spending a request on a
      // lookup that cannot match. See `isNumericRouteId`.
      if (!isNumericRouteId(rawId)) {
        this.navigateToNotFoundPage();
        return;
      }

      // Which product this deployment publishes at this URL. `null` means the
      // country has no such product, so the page answers 404 instead of
      // rendering an empty shell that Prerender.io would cache as a valid 200.
      // The resolver also folds in the handful of ids that moved between
      // products, keyed on id AND slug (see `PRODUCT_REDIRECTS`).
      const resolved = this.productCatalog.resolveRoute(
        rawId,
        params.get("name")
      );
      if (!resolved) {
        this.navigateToNotFoundPage();
        return;
      }

      this.productId = resolved.entry.id;
      this.showInvestor = resolved.entry.kind === "investor-survey";
      this.applyHeaderImageAlt(resolved.entry.kind);

      // Canonicalization no longer waits on the fetch: the catalog already knows
      // this URL's ONE canonical spelling, so the address bar is corrected — and
      // the crawler's 301 emitted — even when the backend is down. Every stale
      // spelling converges here: a retired id, a wrong-language slug, or an id
      // that moved to another product.
      const canonicalUrl = this.urlCanonical.apply(resolved.canonicalPath);
      this.metaTagService.addCanonicalTag(canonicalUrl);
      // Per-language hreflang: the :name slug is language-dependent, so build
      // each language's URL from the catalog rather than the CMS short name.
      this.metaTagService.addHreflangTags(`products/${this.productId}`, lang =>
        this.productCatalog.buildBasePath(resolved.entry, lang)
      );

      this.productService
        .getProduct(this.productId)
        .pipe(timeout(20000)) // bound the wait; a hung backend degrades to the 503 branch in ~20s
        .subscribe(
          product => {
            // A 200 carrying no product is a miss too, not a render.
            if (!product || !product.id) {
              this.navigateToNotFoundPage();
              return;
            }
            this.product = product;
            this.metaTagService.setProductPageMetaTags(this.product);
            this.isVideo = !!product.headerExtraVideoUrl;
            if (this.isVideo) {
              this.videoId = product.headerExtraVideoUrl
                .split("v=")[1]
                .split("&")[0];
            }
            if (product.assetCoverage) {
              this.totalAssetItems = Object.keys(
                product.assetCoverage
              ).filter(item => item.includes("item"));
            }

            if (product.marketCoverage) {
              this.totalMarketItems = Object.keys(
                product.marketCoverage
              ).filter(
                item => item.includes("item") && product.marketCoverage[item]
              );
            }
          },
          (err: HttpErrorResponse) => {
            if (isMissingEntity(err)) {
              this.navigateToNotFoundPage();
              return;
            }
            // Network error / 20s timeout → temporarily unavailable. Stay on the
            // URL; `setPrerenderStatusCode` also clears any 301 pair emitted
            // earlier for an off-canonical slug.
            this.isServiceUnavailable = true;
            this.metaTagService.setPrerenderStatusCode(503);
            this.ngxLogger.error("Grocs: product fetch failed", err);
          }
        );
    });
    this.responsiveChanges();
  }
  ngOnDestroy(): void {
    this.routerSub.unsubscribe();
    this.responsiveSub.unsubscribe();
  }

  responsiveChanges() {
    this.responsiveSub = this.responsive
      .observe(Breakpoints.XSmall)
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }

  openContactDialog(page: string, action: string) {
    this.demo.open(
      DemoDialogComponent,
      false,
      this.i18.getTranslation(page),
      action,
      "",
      this.i18.getTranslation(this.product.productShortName)
    );
  }

  openSiilaIndex() {
    window.open(
      this.i18.buildLocalizedPath(`${environment.applicationURL}/siila_index`),
      this.isMobile ? "_self" : "_blank"
    );
  }

  loadSbiImage() {
    let img = "../../../../../assets/img/analytics-list/";
    if (this.currentCode == "mx") {
      if (this.browserLang == "en") {
        img = img + "NOTE-SMI-MXEN copiar.png";
      } else {
        img = img + "NOTE-SMI-MXES copiar.png";
      }
    } else {
      if (this.browserLang == "en") {
        img = img + "NOTE-SBI-BREN copiar.png";
      } else {
        img = img + "NOTE-SBI-BRPT copiar.png";
      }
    }

    return img;
  }
}
